import { LocationStrategy } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { IPartnerConfig } from 'src/app/models/partner-config.model';
import { SoloModeProvider } from 'src/app/providers/solo-mode.provider';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() public footerLogo = false;
  public baseUrl: string = '/';
  public currentDate = new Date();
  public filter: FormGroup;
  public pageConfig: IPartnerConfig;
  isSoloMode: any;

  constructor(
    private locationStrategy: LocationStrategy,
    private soloModeProvider: SoloModeProvider,
    private fb: FormBuilder
  ) {
    this.baseUrl = this.locationStrategy.getBaseHref();
  }

  ngOnInit() {
    this.isSoloMode = this.soloModeProvider.isSoloMode;

    const begin = new Date();
    const end = new Date();

    end.setDate(begin.getDate() + 2);
    this.filter = this.fb.group({
      date: [{ begin: moment(begin), end: moment(end) }, this.validateInterval],
    });
  }

  private validateInterval(control) {
    const { begin, end } = control.value;
    const today = moment();

    return begin.endOf('day').isBefore(today) || end.endOf('day').isBefore(today) ? { isBeforeToday: true } : null;
  }
}
